import { computed, type ComputedRef } from 'vue'
import { useAuth } from '#imports'

/**
 * True when the user should see authenticated shell UI (navbar profile, etc.).
 * During @sidebase/nuxt-auth getSession(), status is "loading"; we still treat
 * the user as logged in if we already have a token or session data.
 */
export function useAuthShellLoggedIn(): ComputedRef<boolean> {
  const { status, data, token } = useAuth()
  return computed(
    () =>
      status.value === 'authenticated' ||
      (status.value === 'loading' && (!!token.value || !!data.value)),
  )
}
